import moment from 'moment'
import 'moment/locale/es'

export const TRADEIN_MINDATE = moment(process.env.REACT_APP_TRADEIN_MINDATE).toDate()
